import { IOperationItem } from '@/common/integrations/menhir/employee/operations/operations.types';
import { useOperationAction } from '@/web/components/TransactionList/components/OperationDetail/utils';
import { TMoney } from '@coverflex-tech/hypernova-utils';
import {
  TTransactionRow,
  TransactionsTable,
} from '../TransactionsTable/TransactionsTable';
import { useItemProps } from './OperationsTable.utils';

export function OperationsTable({
  transactions,
}: {
  transactions: IOperationItem[];
}) {
  const { getTransactionAction } = useOperationAction();

  const { getItemProps } = useItemProps();

  const rows: TTransactionRow[] = transactions.map((transaction) => {
    const itemProps = getItemProps(transaction);
    const externalCardValue = transaction.descriptionParams?.find(
      (param) => param.key === 'external_card_value'
    )?.value as TMoney;
    const creditsValue = transaction.descriptionParams?.find(
      (param) => param.key === 'credits_value'
    )?.value as TMoney;
    return {
      icon: itemProps.icon,
      date: transaction.executedAt,
      description: itemProps.description,
      statusBadge: itemProps.badge,
      amount: transaction.amount,
      isDebit: transaction.isDebit,
      disabled: ['rejected', 'cancelled'].includes(transaction.status),
      action: getTransactionAction(transaction),
      secondaryAmount: externalCardValue ?? creditsValue,
    };
  });

  return <TransactionsTable rows={rows} />;
}
